module.exports = __webpack_public_path__ + "assets/dashboard-icon-percentageExposedToVidjet-selected.78576cbc.svg";